import { defineComponent } from 'vue';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiButtonGroup",
  props: {
    buttons: { type: Array, required: true },
    value: { type: [String, Number], required: true }
  },
  emits: ["input"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const isButtonActive = (button) => {
      return props.value === button.key;
    };
    const isButtonDisabled = (button) => {
      var _a;
      return (_a = button.disabled) != null ? _a : false;
    };
    const changeActiveButton = (button) => {
      if (isButtonDisabled(button) || isButtonActive(button)) {
        return;
      }
      emits("input", button.key);
    };
    return { __sfc: true, props, emits, isButtonActive, isButtonDisabled, changeActiveButton };
  }
});

export { _sfc_main as default };
